import { render, staticRenderFns } from "./SectionBanner.vue?vue&type=template&id=98d90c98&scoped=true"
import script from "./SectionBanner.vue?vue&type=script&lang=js"
export * from "./SectionBanner.vue?vue&type=script&lang=js"
import style0 from "./SectionBanner.vue?vue&type=style&index=0&id=98d90c98&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d90c98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98d90c98')) {
      api.createRecord('98d90c98', component.options)
    } else {
      api.reload('98d90c98', component.options)
    }
    module.hot.accept("./SectionBanner.vue?vue&type=template&id=98d90c98&scoped=true", function () {
      api.rerender('98d90c98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/SectionBanner.vue"
export default component.exports